import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { UNSELECTED_SENTINEL } from "../constants/floorAgeOptions";

/**
 * Single-choice, touch-friendly select over a fixed option list, with a
 * "Mevcut kayıt: …" fallback line for legacy values that don't map into the
 * option list.
 *
 * Props:
 *   value            — current option value (empty string means unselected)
 *   onChange(v)      — called with new option value
 *   options          — [{ value, label }]
 *   placeholder      — shown when unselected
 *   legacyText       — original stored value if it wasn't representable
 *   testId           — data-testid for the trigger
 *   className        — extra classes for the trigger
 */
export default function SingleChoiceSelect({
  value = "",
  onChange,
  options,
  placeholder,
  legacyText,
  testId,
  className = "",
}) {
  // Radix Select cannot use "" as an item value → map to a sentinel.
  const displayValue =
    value === "" || value == null ? UNSELECTED_SENTINEL : value;

  return (
    <div>
      <Select
        value={displayValue}
        onValueChange={(v) => onChange(v === UNSELECTED_SENTINEL ? "" : v)}
      >
        <SelectTrigger
          data-testid={testId}
          className={
            "mt-1 bg-white dark:bg-[#09090B] border-[#E4E4E7] dark:border-[#27272A] " +
            className
          }
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className="max-h-[320px]">
          <SelectItem value={UNSELECTED_SENTINEL} className="text-[#52525B] dark:text-[#A1A1AA]">
            {placeholder || "—"}
          </SelectItem>
          {options.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {legacyText && (
        <div className="text-[10px] text-[#52525B] dark:text-[#A1A1AA] mt-1">
          Mevcut kayıt: {legacyText} — yeni bir seçim yapmadan kaydederseniz
          bu değer korunur.
        </div>
      )}
    </div>
  );
}
